var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44.75,
    height: 44.75,
    rx: 8,
    fill: "#50CD89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7917 13.25H15.9583C14.1887 13.25 12.75 14.6887 12.75 16.4583V29.4187C12.75 31.1461 14.1591 32.5 15.9583 32.5H28.7917C30.5909 32.5 32 31.1461 32 29.4187V16.4583C32 14.6887 30.5613 13.25 28.7917 13.25ZM29.4333 29.4187C29.4333 29.9179 28.8571 29.9332 28.7917 29.9332H15.9583C15.8929 29.9332 15.3167 29.9179 15.3167 29.4187V16.4582C15.3167 16.1041 15.6042 15.8166 15.9583 15.8166H28.7917C29.1446 15.8166 29.4333 16.1041 29.4333 16.4582V29.4187Z",
    fill: "#E8FFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.2532 24.0322L26.5663 18.719L26.5664 18.719L26.6371 18.7897L21.2532 24.0322ZM21.2532 24.0322L18.1834 20.9621L18.1834 20.9621C18.0893 20.868 17.9367 20.868 17.8426 20.9621L16.8456 21.9591C16.8004 22.0043 16.775 22.0656 16.775 22.1296C16.775 22.1934 16.8004 22.2548 16.8456 22.3L21.0829 26.5373C21.1281 26.5825 21.1893 26.6079 21.2533 26.6079C21.3173 26.6079 21.3785 26.5825 21.4237 26.5373L27.9044 20.0566C27.9496 20.0114 27.975 19.9502 27.975 19.8862L27.975 19.8859C27.9748 19.8218 27.9492 19.7609 27.9042 19.716L21.2532 24.0322Z",
    fill: "#E8FFF3",
    stroke: "#E8FFF3",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/ApprovedIcon.ba0c62db56ad8db85a69961e50ae94c3.svg";
export { ForwardRef as ReactComponent };